import Long from 'long';
export { GetChildId, GetRangeOfSubtree } from './PPCBase';
export * from './PPCDataReader';
export * from './PPCHReader';
export { getOctantsArray, PPCOctant, PPCVoxelAttribute } from './PPCI';
export * from './PPCTag';
export { RedBlackTree, RedBlackTreeNode } from './util/RedBlackTree';

export const ZERO_LONG = Long.UZERO;
export const TAGCOMPOSITE = 0;
export const TAGVARCARD = 0x40;
export const TAGREAL = 0x80;
export const TAGBINARY = 0xc0;
export const TAGBOOLEAN = TAGVARCARD;
export const TAGSTRING = TAGBINARY;
export const CHILDINFO = 0;
export const TILE3DOFFSET = 1;
export const XYZ = 2;
export const RGB = 3;
export const INTENSITY = 4;
export const CLASSIFICATION = 5;
export const DIFFERENCE = 6;
export const SEGMENT = 7;
export const SOURCE = 8;
export const MAXATTRIBUTE = SOURCE;
